import React from 'react';
import { PageProps } from './interfaces/ComponentProps';

function LegacyRedirect({ country, lang }: PageProps) {
  React.useEffect(() => {
    const currentPath = process.env.REACT_APP_SiteUrl ?? "";

    window.location.replace(`${currentPath}/${country}/onboard/${lang}`);
  }, [country]);

  return null;
}

export default LegacyRedirect;
